<script setup>
// BonBoZ: bo cap tab Tra loi/Luu y va nut Copilot — truc page chi tra loi khach,
// luu y noi bo nam o muc Ghi chu ben panel phai.
import { computed, onMounted } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { CHAR_LENGTH_WARNING, REPLY_EDITOR_MODES } from './constants';

const props = defineProps({
  isMessageLengthReachingThreshold: { type: Boolean, default: false },
  charactersRemaining: { type: Number, default: 0 },
});

const emit = defineEmits(['setReplyMode', 'toggleEditorSize']);

// BonBoZ: khong con tab de doi tay, nen panel nay chot che do tra loi mot lan khi mo.
onMounted(() => emit('setReplyMode', REPLY_EDITOR_MODES.REPLY));

const charLengthClass = computed(() =>
  props.charactersRemaining < 0 ? 'text-n-ruby-9' : 'text-n-slate-11'
);

const characterLengthWarning = computed(() =>
  props.charactersRemaining < 0
    ? `${-props.charactersRemaining} ${CHAR_LENGTH_WARNING.NEGATIVE}`
    : `${props.charactersRemaining} ${CHAR_LENGTH_WARNING.UNDER_50}`
);
</script>

<template>
  <!-- BonBoZ: mot o that o CUOI DONG NHAP, khong con neo tuyet doi.
       Ban cu `absolute top-1 right-1` hop khi khung soan cao 64px — nut nam
       tren khoang trong phia tren chu. Khung gio cao mot dong nen mieng de do
       roi thang xuong chu dang go. Nam trong hang thi no tu day duoc o soan
       ngan lai dung bang cho no chiem. -->
  <div class="flex flex-shrink-0 gap-2 items-center self-start">
    <div class="text-xs">
      <span v-if="isMessageLengthReachingThreshold" :class="charLengthClass">
        {{ characterLengthWarning }}
      </span>
    </div>
    <!-- `xs` (h-6 = 24px) chu khong phai `sm` (h-8 = 32px): hang nhap cao dung
         mot dong 24px, nut 32px la rieng no keo ca hang len 32px — chu bi ep
         sat mep tren, con tren duoi nut thi thua ra mot khoang trong. -->
    <NextButton
      ghost
      class="text-n-slate-11"
      xs
      icon="i-lucide-maximize-2"
      @click="emit('toggleEditorSize')"
    />
  </div>
</template>
